export function coordinationTimeString(paceValue: number, options: { signDisplay?: boolean } = {}): string {
  const { signDisplay } = options;
  const hours = Math.floor(Math.abs(paceValue));
  const minutes = Math.round(Math.abs((paceValue % 1) * 60));
  const hoursAndMinutesString = minutes <= 0 ? `${hours}h` : `${hours}h ${minutes}m`;
  return `${paceValue < 0 ? '-' : signDisplay ? '+' : ''}${hoursAndMinutesString}`;
}
